import { createFeatureStateSelector, createSelector } from "mini-rx-store";
import type { StartseiteState } from "./startseite-reducer.js";

/**
 * Selectors der Startseite.
 *
 * Je Block einer: So bekommt jede Section genau ihren Ausschnitt und rendert
 * nur neu, wenn sich dieser ändert — die Blöcke selbst kennen weiterhin nur
 * ihre Daten, nicht deren Herkunft.
 */
const selectStartseiteFeature = createFeatureStateSelector<StartseiteState>("startseite");

export const selectVerzeichnisse = createSelector(selectStartseiteFeature, (s) => s.verzeichnisse);

/** Die Gebiete tragen Block 0 und den Steckbrief des gemerkten Gebiets. */
export const selectGebiete = createSelector(selectVerzeichnisse, (v) => v?.gebiete);
/** Parteien brauchen mehrere Blöcke — Farben und Kurznamen. */
export const selectParteien = createSelector(selectVerzeichnisse, (v) => v?.parteien);
export const selectWahlen = createSelector(selectVerzeichnisse, (v) => v?.wahlen);
export const selectAktuelleWahlen = createSelector(selectVerzeichnisse, (v) => v?.aktuelleWahlen);
export const selectGremien = createSelector(selectVerzeichnisse, (v) => v?.gremien);
export const selectFraktionen = createSelector(selectVerzeichnisse, (v) => v?.fraktionen);
export const selectDatenstand = createSelector(selectVerzeichnisse, (v) => v?.datenstand);
/** Wörtliche Attributionen der gelesenen Dokumente — nie umformulieren. */
export const selectAttributionen = createSelector(selectVerzeichnisse, (v) => v?.attributionen);

/** Sitzverteilung des Rates — amtlich übertragen, fehlt ohne Sitzplan. */
export const selectSitzverteilung = createSelector(selectVerzeichnisse, (v) => v?.sitzverteilung);
export const selectGremienDerStadt = createSelector(selectVerzeichnisse, (v) => v?.gremienDerStadt);
export const selectDezernate = createSelector(selectVerzeichnisse, (v) => v?.dezernate);
export const selectQuellen = createSelector(selectVerzeichnisse, (v) => v?.quellen);

export const selectAufmacher = createSelector(selectStartseiteFeature, (s) => s.aufmacher);
export const selectAufmacherFuer = createSelector(selectStartseiteFeature, (s) => s.aufmacherFuer);
